import { render } from "./VideoWallPresetSelectItem.vue?vue&type=template&id=08bfe583&ts=true"
import script from "./VideoWallPresetSelectItem.vue?vue&type=script&lang=ts"
export * from "./VideoWallPresetSelectItem.vue?vue&type=script&lang=ts"

import "./VideoWallPresetSelectItem.vue?vue&type=style&index=0&id=08bfe583&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__